<template>
  <div>
    <SimplePageHeader title="Team's Members">
      <template v-slot:right-buttons>
        <h3>
          Override:
          {{ commissionOverridePercentage | percent }}
        </h3>
      </template>
    </SimplePageHeader>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          dense
          :headers="headers"
          :items="teamMemberGrossProfitItems"
          :items-per-page="5"
          class="mb-3"
        >
          <template v-slot:item.totalCommission="{ item }">
            {{ item.totalCommission | currency }}
          </template>
          <template v-slot:item.totalIndividualGP="{ item }">
            {{ item.totalIndividualGP | currency }}
          </template>
          <template v-slot:item.consultantsGP="{ item }">
            {{ item.consultantsGP | currency }}
          </template>
          <template v-slot:item.permPlacementsGP="{ item }">
            {{ item.permPlacementsGP | currency }}
          </template>
          <template v-slot:item.commissionOverride="{ item }">
            {{ item.commissionOverride | currency }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mx-1 my-1 hide-on-print"
              color="primary"
              outlined
              @click.prevent="viewCommissionDetails($event, item)"
            >
              <v-icon color="primary">paid</v-icon>
            </v-btn>
          </template>
          <template v-slot:body.append>
            <tr>
              <td></td>
              <td></td>
              <td>
                <b>TOTAL:</b>
              </td>
              <td>{{ totalIndividualGP | currency }}</td>
              <td>{{ totalOverride | currency }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import { commissionDetailsReportRoute } from '@/lib/constants/routes'
import { HOURLY as HOURLY_PAID } from '@/lib/constants/payRateTypes'
import { HOURLY as HOURLY_BILLED } from '@/lib/constants/billRateTypes'

export default {
  components: {
    SimplePageHeader
  },
  props: [
    'teamMemberGrossProfitItems',
    'commissionOverridePercentage'
  ],
  data () {
    return {
      HOURLY_PAID,
      HOURLY_BILLED,
      assignmentId: null,
      headers: [
        { text: 'Internal Employee', value: 'employeeName', width: '20%' },
        { text: 'Consultants GP', value: 'consultantsGP', class: 'pl-4 pr-0', width: '16%' },
        { text: 'Perm. Placements GP', value: 'permPlacementsGP', class: 'pl-4 pr-0', width: '20%' },
        { text: 'Individual GP', value: 'totalIndividualGP', class: 'pr-0', width: '16%' },
        { text: 'Override', value: 'commissionOverride', width: '14%' },
        { text: 'Details', sortable: false, value: 'actions', align: 'center', class: 'hide-on-print px-1', cellClass: 'hide-on-print px-0', width: '12%' }
      ]
    }
  },
  computed: {
    totalIndividualGP () {
      return this.teamMemberGrossProfitItems.reduce((accumulator, object) => {
        return accumulator + object.totalIndividualGP
      }, 0)
    },
    totalOverride () {
      return this.teamMemberGrossProfitItems.reduce((accumulator, object) => {
        return accumulator + object.commissionOverride
      }, 0)
    }
  },
  methods: {
    viewCommissionDetails (event, item) {
      const routeData = this.$router.resolve({
        name: commissionDetailsReportRoute.name,
        query: {
          user: item.employeeUserId,
          year: item.year,
          month: item.month
        }
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    }
  }
}
</script>
